import React from 'react';

const StarBackground = () => {
  return (
    <>
      <div className="star"></div>
      <div className="star"></div>
      <div className="star"></div>
      <div className="star"></div>
      <div className="star"></div>
      <div className="star"></div>
      <div className="star"></div>
    </>
  );
};

export default StarBackground; 